<template>
  <v-footer
    app
    class="site-footer"
    :class="`variant-${$props.variant || 'default'}`"
    color="white"
    :order="order"
  >
    <div class="site-footer-content">
      O3, Inc.

      <span v-if="version">
        &mdash; Build {{ version }}
      </span>

      <v-chip
        v-if="showChip"
        class="env-chip ml-1"
        :class="chipColor"
        pill
        size="x-small"
      >
        {{ environment }}
      </v-chip>
    </div>
  </v-footer>
</template>

<script setup lang="ts">
defineProps<{
  variant?: 'default' | 'auth'
}>();
const version = useBuildVersion();
const environment = useEnvironmentTag();
const showChip = environment !== 'PROD';
const chipColor = computed(() => {
  switch (environment) {
    case 'DEV':
      return 'purple';
    case 'UAT':
      return 'orange';
    default:
      return 'gray';
  }
});
const order = useAppConfig().layoutOrders.siteFooter;
</script>

<style scoped lang="scss">
@use "sass:map";
@import "vuetify/styles/settings/variables";
@import "~/assets/styles/variables";

.site-footer {
  font-size: 0.875rem;
  border-top: 1px solid $faint-line;
  text-align: right;
  color: $muted-light !important;
}

.site-footer-content {
  width: 100%;
}

.v-chip.env-chip {
  --v-chip-height: 18px;
  font-weight: bold;
  top: -1px;
  color: white;

  &.gray {
    background-color: $ash-gray;
  }

  &.purple {
    background-color: $dev-purple;
  }

  &.orange {
    background-color: $uat-orange;
  }
}

@media (min-width: $auth-page-sm-and-up) {
  .site-footer {
    &.variant-auth {
      padding: 0;
      border: none;
      background-color: transparent !important;
      color: white !important;

      & > .site-footer-content {
        background-color: rgba(0, 0, 0, 0.5);
        position: fixed;
        padding: 1rem;
        bottom: 0;
        right: 0;
        width: auto;
      }
    }
  }
}
</style>
